import { Injectable } from '@angular/core';
import { HttpService } from 'projects/apex/src/app/services/http/http.service';
import { EntryGroup } from './entry-group.model';

@Injectable()
export class EntryGroupService extends HttpService<EntryGroup> {
  route = 'entry-group';
}
